import React, { useState } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Box, Button, MenuItem, styled } from "@mui/material";
import { Modal } from "src/components/Modal/ServicesModal/Modal";
import { useAppDispatch, useAppSelector } from 'src/hooks/redux';
import { PenMenuIcon, PlusIcon, TrashBinMenuIcon } from 'src/Icons';
import { getCategoryTemplates, removeCategoryTemplate } from "src/store/reducers/categoryTemplatesSlice";
import { closeModal, showModal } from "src/store/reducers/modalSlice";
import { getStudios } from "src/store/reducers/studiosSlice";
import { removeCategories } from "src/store/reducers/categoriesSlice";
import { ActionMenu } from "src/styledComponents";
import {
  initialServicesDialogParams,
  setServicesDialogParams,
  showServicesDialog
} from 'src/store/reducers/dialogSlice';

import { CustomActionCardMenuActionType } from "./CustomActionCardMenu.types";


const ActionDotsButton = styled(Button)({
  color: "#363636",
  "&:hover": {
    backgroundColor: "transparent",
  },
  minWidth: '16px',
});

export function CustomActionCardMenu ({ data, icon }: any) {
  const dispatch = useAppDispatch();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const [actionType, setActionType] = useState(
    CustomActionCardMenuActionType.EditCategory
  );
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const { studio: selectedStudio } = useAppSelector((state: any) => state.selectedStudio);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event: any) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(null);
  };

  const handleSaveButtonPress = () => {
    dispatch(
      showModal({
        modalType: "SUCCESS",
        successText: "Category is successfully deleted",
        okButtonTitle: "Ok, I got it",
        onButtonClick: () => {
          dispatch(closeModal());
        },
      })
    );
  };

  const handleAddService = () => {
    dispatch(closeModal());
    dispatch(setServicesDialogParams({
      step: 0,
      maxAvailableStep: 0,
      isEdit: false,
      data: {
        category: data,
        ...initialServicesDialogParams.data
      },
    }));
    dispatch(showServicesDialog());
  };

  const handleDeleteCategory = () => {
    if (selectedStudio) {
      dispatch(
        showModal({
          modalType: "DELETE",
          headerTitle: "Are you sure?",
          title:
            "Deleting the service category will result in all assotiated services being uncategorized",
          subTitle:
            "Please, confirm if you want to proceed with this action",
          okButtonTitle: "Yes, delete category",
          onButtonClick: () => {
            dispatch(removeCategories({
              categoriesId: data.id,
              studioId: selectedStudio.id,
              onSuccess: () => {
                dispatch(
                  showModal({
                    modalType: "DELETE",
                    headerTitle: "Are you sure?",
                    title:
                      "Deleting the service category will result in all assotiated services being uncategorized",
                    subTitle:
                      "Please, confirm if you want to proceed with this action",
                    okButtonTitle: "Yes, delete category",
                    onButtonClick: () => {
                      dispatch(closeModal());
                      handleSaveButtonPress();
                      dispatch(getStudios());
                    },
                  })
                );
              },
              onFailure: () => {
                dispatch(closeModal());
              }
            }));
          },
        })
      );
    } else {
      dispatch(
        showModal({
          modalType: "DELETE",
          headerTitle: "Are you sure?",
          title:
            "Deleting the service category will result in all assotiated services being uncategorized",
          subTitle:
            "Please, confirm if you want to proceed with this action",
          okButtonTitle: "Yes, delete category",
          onButtonClick: () => {
            dispatch(removeCategoryTemplate({
              categoriesId: data.id,
              onSuccess: () => {
                dispatch(showModal({
                  modalType: "SUCCESS",
                  successText: "Category is successfully deleted",
                  okButtonTitle: "Ok, I got it",
                  onButtonClick: () => {
                    dispatch(closeModal());
                    dispatch(getCategoryTemplates());
                  },
                }));
              },
              onFailure: () => {
                dispatch(closeModal());
              }
            }));
          },
        })
      );
    }
  };

  const handleAction = (action: CustomActionCardMenuActionType) => {
    return () => {
      switch (action) {
        case CustomActionCardMenuActionType.EditCategory:
          setActionType(CustomActionCardMenuActionType.EditCategory);
          setIsDialogOpen(true);
          console.log("should add Edit category");
          break;
        case CustomActionCardMenuActionType.AddService:
          handleAddService();
          console.log("should add Add subctegory");
          break;
        case CustomActionCardMenuActionType.DeleteCategory:
          handleDeleteCategory();
          console.log("should add Delete ");
          break;
        default:
          throw new Error("Not proper CustomActionCardMenu");
      }
      setAnchorEl(null);
    };
  };

  return (
    <Box
      sx={{
        display: "flex",
      }}
      onClick={(event) => {event.stopPropagation()}}
    >
      <Modal
        data={data}
        studioId={selectedStudio?.id}
        typeOfServiceId={actionType}
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        onSubmit={() => setIsDialogOpen(false)}
      />
      <ActionDotsButton
        id="action-dot-button"
        aria-controls={open ? "dot-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        disableRipple
      >
        {/*eslint-disable*/}
        { icon ? icon : <MoreVertIcon />}
      </ActionDotsButton>
      <ActionMenu
        id="action-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "action-button",
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MenuItem
          onClick={(event) => {
            event.stopPropagation();
            handleAction(CustomActionCardMenuActionType.AddService)();
          }}
          disableRipple
        >
          <PlusIcon />
          Add service
        </MenuItem>
        <MenuItem
          onClick={(event) => {
            event.stopPropagation();
            handleAction(CustomActionCardMenuActionType.EditCategory)();
          }}
          disableRipple
        >
          <PenMenuIcon />
          Edit category
        </MenuItem>
        <MenuItem
          onClick={(event) => {
            event.stopPropagation();
            handleAction(CustomActionCardMenuActionType.DeleteCategory)();
          }}
          disableRipple
        >
          <TrashBinMenuIcon />
          Delete category
        </MenuItem>
      </ActionMenu>
    </Box>
  );
}
